const cleanNumberSearch = (search) => (search ? search.replace(/[^0-9]/g, '') : '');

export default cleanNumberSearch;
